import api from '../../api/'
const state = {
    all:[],
    typeoperation:[],
    sensoperations:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: 1,
            code: "",
            entetetypeoperation_libelle: "",
            // plafond: "",
            // periode_plafond: "",
            grilletarifaire_libelle: "",
            tva: "",
            commission: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.all.forEach(element => {           
            row = {
                id: element.id,
                code: element.code,
                entetetypeoperation_libelle: element.entetetypeoperation_libelle,
                // plafond: element.plafond.toLocaleString(),
                // periode_plafond: element.periode_plafond,
                grilletarifaire_libelle: element.grilletarifaire_libelle,
                sensoperation_libelle: element.sensoperation_libelle,
                tva: element.tva,
                commission: element.commission,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at
            }
            data.push(row)
        });
        return data;
    },
    sens(state){
        let data = []
        let row = {
            libelle: ""
        }
        state.sensoperations.forEach(element => { 
            //console.log(element)          
            row = {
                libelle: element
            }
            data.push(row)
        });
        return data;
    },
    type(state){
        let data=[]
        let typeop = {
            code:"",
            libelle:""
        } 
        state.typeoperation.forEach(element => {
            //console.log(element)          
            typeop = {
                code: element.code,
                libelle: element.libelle
            }
            data.push(typeop)
        });
        return data;
    }
}
const mutations= {
    setTypeoperations(state, typeoperations) {
        state.all = typeoperations
    },
    setCodeoperations(state, typeoperations) {
        state.typeoperation = typeoperations
    },
    setSensoperations(state, sensoperation) {
        state.sensoperations = sensoperation
    },
    addTypeoperations(state, typeoperation) {
        state.all.push(typeoperation)
    }
}

const actions={
    get_all_typeoperations({ commit }, serverParams){
        return api.typeoperation.get_all_typeoperations(serverParams).then((response)=>{
            
            commit('setTypeoperations', response.data.data.data)
            return response.data.data
        })
    },
    get_all_sensoperations({ commit }){
        return api.typeoperation.get_all_sensoperations().then((response)=>{
            commit('setSensoperations', response.data.data)
            return response.data.data
        })
    },
    typeoperations({ commit }){
        return api.typeoperation.typeoperations().then((response)=>{
            
            commit('setCodeoperations', response.data.data.data)
            return response.data.data
        })
    },
    post_typeoperations({ commit }, typeoperation){
        return api.typeoperation.post_typeoperations(typeoperation).then((response)=>{
            return response.data
        })
        .catch(error=>{
            console.log("error ",error.response)
            return error.response.data
        })
    },
    put_typeoperations({ commit }, data) {
        return api.typeoperation.put_typeoperations(data.code, data).then((response) => {
            return response.data
        })
        .catch(error => {
            return error.response.data
        })
    },
    show_typeoperations({ commit }, code_operations) {
        return api.typeoperation.show_typeoperations(code_operations).then((response) => {
            return response.data.data;
        })
    }
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
